import { Device, until } from '@helpers/media';
import { withMotion } from '@hoc/withMotion';
import BrandCard from '@stories/Components/Cards/BrandCard/BrandCard';
import CarouselProvider from '@stories/Components/Misc/Carousels/Carousel/CarouselProvider/CarouselProvider';
import Pagination from '@stories/Components/Misc/Carousels/Carousel/Pagination/Pagination';
import HeadingSummaryBlock from '@stories/Components/Misc/HeadingSummaryBlock/HeadingSummaryBlock';
import { MotionConfig } from 'framer-motion';
import * as React from 'react';
import S from './BrandCards.styles';
const BrandCards = (props) => {
    const imageSizes = `${until(Device.MobileLarge)} 100vw, ${until(Device.TabletSmall)} 50vw, ${until(Device.TabletLarge)} 33vw, ${until(Device.DesktopSmall)} 25vw, ${until(Device.DesktopLarge)} 17vw, 260px`;
    if (!props.groups) {
        return null;
    }
    return (React.createElement(S.Container, { id: props.anchorId, translations: props.translations },
        React.createElement(HeadingSummaryBlock, { ...props, summary: props.summary ? `<p>${props.summary}</p>` : undefined, layout: props.summary ? 'split' : 'central' }),
        React.createElement(MotionConfig, { transition: { duration: 0.3, ease: 'easeOut' } }, props.groups.map((group) => (React.createElement(BrandGroup, { key: group.heading, ...group, showHeading: props.groups.length > 1, imageSizes: imageSizes }))))));
};
const BrandGroup = (props) => {
    return (React.createElement(CarouselProvider, { count: props.items.length, paddingOffset: 16 },
        props.showHeading && React.createElement(S.Heading, null, props.heading),
        React.createElement(S.CarouselWrapper, null,
            React.createElement(S.Track, { trackMutations: true }, props.items.map((card) => (React.createElement(S.Item, { key: card.id },
                React.createElement(BrandCard, { ...card, headingType: props.showHeading ? 'h4' : 'h3', sizes: props.imageSizes, imageOnly: props.imageOnlyCards }))))),
            React.createElement(Pagination, null))));
};
export default withMotion(BrandCards);
